
export const Direction = {
  UP: 0,
  DOWN: 1,
  LEFT: 2,
  RIGHT: 3,
};

export const GameState = {
  IDLE: 0,
  PLAYING: 1,
  PAUSED: 2,
  GAME_OVER: 3,
};

export const Difficulty = {
  EASY: 0,
  MEDIUM: 1,
  HARD: 2,
};

export const PowerUpType = {
  SLOW_MOTION: 0,
  GHOST_MODE: 1,
};
